import PhotoSizeDimensions from '@alltrails/types/PhotoSizeDimensions';
import { X_AT_KEY } from './api';
import getPhotoSizeServerFromDimensions from './getPhotoSizeServerFromDimensions';

type Args = {
  baseUrl?: string;
  id: string | number;
  index: number;
  size: PhotoSizeDimensions;
};

const getCustomRoutePhotoUrl = ({ baseUrl, id, index, size }: Args) => {
  const params = new URLSearchParams();
  params.set('key', X_AT_KEY);
  params.set('size', getPhotoSizeServerFromDimensions(size));
  params.set('landscape', 'true');

  return `${baseUrl || ''}/api/alltrails/maps/${id}/photos/carousel/${index}?${params.toString()}`;
};

export default getCustomRoutePhotoUrl;
